module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.filteredColumns), function(column) {
    return _c('th', {
      key: column.name,
      style: ('width:' + column.width + ';' + 'cursor:pointer;')
    }, [_c('span', {
      class: _vm.sortKey === column.name ? (_vm.sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting',
      on: {
        "click": function($event) {
          return _vm.$emit('sort', column.name)
        }
      }
    }, [_vm._v(_vm._s(column.label))])])
  }), 0)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-438f04f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DataTable.vue
// module id = 1874
// module chunks = 1